// @flow
/* eslint-disable */
import React from 'react';
import * as classnames from 'classnames';
import styles from './styles.module.scss';
import { H4 } from '../Typography';
import cards from '../../assets/images/CardComp.png'
import cardsPlo5 from '../../assets/images/CardCompPLO5.png'
import cardsBlue from '../../assets/images/CardCompBlue.png'
import cardsGreen from '../../assets/images/CardCompGreen.png'
import cardsPlo5Blue from '../../assets/images/CardCompPLO5Blue.png'
import cardsPlo5Green from '../../assets/images/CardCompPLO5Green.png'

type Props = {
  bet: number,
  position: string,
  selectedPosition?: string,
  className?: string,
  betOnTable?: number,
  opponent: string,
  opponent2?: string,
  hu?: boolean,
  ante?: boolean,
  opponentPercentage?: any,
  category?: string,
  isLoading?: boolean,
  isPlo5?: boolean,
  cardColor?: string,
  handleCardClick?: () => void,
}

const PositionCircle = ({
  bet, position, selectedPosition = '', className, betOnTable = '', opponent, index, opponent2 = '', stackSize, hu, ante, opponentPercentage, category, isLoading, isPlo5, cardColor, handleCardClick
}: Props) => {
  const _betOnTable = +betOnTable > +stackSize ? +stackSize : +betOnTable;
  const isActive = selectedPosition ? selectedPosition.slice(0, 2) === position : false;
  const isOpponent = opponent === position;
  const isOpponent2 = opponent2 === position;
  const isPositionUp = index === 2 || index === 3 || index === 4;
  const isBottom = index === 0;

  // console.log('index', index, selectedPosition);
  const positionDealerChip = classnames(
    styles.dealerChip,
    {  [styles.positionDealerChip0]: index === 0 },
    {  [styles.positionDealerChip1]: index === 1 },
    {  [styles.positionDealerChip2]: index === 2 },
    {  [styles.positionDealerChip3]: index === 3 },
    {  [styles.positionDealerChip4]: index === 4 },
    {  [styles.positionDealerChip5]: index === 5 },
  )

  const positionBet = classnames(
    {  [styles.positionBet0]: index === 0 },
    {  [styles.positionBet1]: index === 1 },
    {  [styles.positionBet2]: index === 2 },
    {  [styles.positionBet3]: index === 3 },
    {  [styles.positionBet4]: index === 4 },
    {  [styles.positionBet5]: index === 5 },
  )

  const nolimpsPositions = ['sbnolimp', 'sbnolimpvsbb']
  const additionLabelPositions = ['sb', 'bb']

  const handleCardColorShow = () => {
    if (isPlo5) {
      switch (cardColor) {
        case 'red': {
          return cardsPlo5
        }
        case 'blue': {
          return cardsPlo5Blue
        }
        case 'green': {
          return cardsPlo5Green
        }
      }
    } else {
      switch (cardColor) {
        case 'red': {
          return cards
        }
        case 'blue': {
          return cardsBlue
        }
        case 'green': {
          return cardsGreen
        }
        case '' : {
          return cards
        }
      }
    }
  }

  const noLimpLabel = () => {
    if ((selectedPosition === 'bbvssbnolimp' || selectedPosition === 'bbvssbnolimp4bet') && position === 'sb') {
      return true
    }
    return (nolimpsPositions.includes(selectedPosition) && additionLabelPositions.includes(position) && isActive)
  }

  const currentOpponent = opponentPercentage?.filter(el => el.stake === position)
  const currentOpponentExists = () => (
    (currentOpponent && currentOpponent.length) ? true : false
  )

  const opponentChooser = () => {
    if (!currentOpponent.length) {
      return null;
    }
    // if (isLoading) {
    //   return null;
    // }
    switch (category) {
      case 'CC/3bet':
        return `${currentOpponent[0]?.raise}%`;
      case 'vs 3bet':
        return `${currentOpponent[0]?.raise}%`;
      case 'SQZ':
        if (position === opponent) {
          return `${currentOpponent[0]?.raise}%`
        }
        if (position === opponent2) {
          return `${currentOpponent[0]?.call}%`
        }
      case 'VS SQZ':
        if (position === opponent) {
          return `${currentOpponent[0]?.call}%`
        }
        if (position === opponent2) {
          return `${currentOpponent[0]?.raise}%`
        }
      case '4BET':
        return `${currentOpponent[0]?.raise}%`
      case 'vs 4bet':
        return `${currentOpponent[0]?.raise}%`
      case 'RFI' || 'rfi':
        if (hu && !isPlo5)
          return `${currentOpponent[0]?.call}%`
        else
          return `${currentOpponent[0]?.limp}%`
      default:
        return null;
    }
  }

  const shouldShowCards = () => {
    if (isBottom) return false;
    if (category === 'RFI' || category === 'rfi' || category === 'easyrfi') {
      if (selectedPosition === 'ep') return true
      if (selectedPosition === 'mp' && position === 'ep') return false
      if (selectedPosition === 'mp') return true
      if (selectedPosition === 'co' && (_betOnTable > 0 || position === 'bu')) return true
    }
    if (category === 'CC/3bet') {
      if (selectedPosition === 'mpvsep') return true
      if (selectedPosition === 'covsep' && position === 'bu') return true
      if (selectedPosition === 'bbvsep' && position === 'sb') return false
      if (selectedPosition === 'covsmp' && position === 'bu') return true
      if (selectedPosition === 'bbvsmp' && position === 'sb') return false
      if (selectedPosition === 'bbvsco' && position === 'sb') return false
      if (selectedPosition === 'bbvsbu' && position === 'sb') return false
    }
    if (category === 'vs 3bet') {
      if (selectedPosition === 'epvsmp' && (position === 'bb' || position === 'sb')) return false
      if (selectedPosition === 'epvsco' && (position === 'bb' || position === 'sb')) return false
      if (selectedPosition === 'epvsbu' && (position === 'bb' || position === 'sb')) return false
      if (selectedPosition === 'epvssb' && position === 'bb') return false
      if (selectedPosition === 'epvsbb' && position === 'sb') return false
      if (selectedPosition === 'mpvsco' && (position === 'bb' || position === 'sb')) return false
      if (selectedPosition === 'mpvsbu' && (position === 'bb' || position === 'sb')) return false
      if (selectedPosition === 'mpvssb' && position === 'bb') return false
      if (selectedPosition === 'mpvsbb' && position === 'sb') return false
      if (selectedPosition === 'covsbu' && (position === 'sb' || position === 'bb')) return false
      if (selectedPosition === 'covssb' && position === 'bb') return false
      if (selectedPosition === 'covsbb' && position === 'sb') return false
      if (selectedPosition === 'buvssb' && position === 'bb') return false
      if (selectedPosition === 'buvsbb' && position === 'sb') return false
    }
    if (category === 'SQZ') {
      if (selectedPosition === 'cosqzep+mp' && position === 'bu') return true
      if (selectedPosition === 'bbsqzco+bu' && position === 'sb') return false
      if (selectedPosition === 'bbsqzmp+co' && position === 'sb') return false
      if (selectedPosition === 'bbsqzep+mp' && position === 'sb') return false
    }
    if (category === 'VS SQZ') {
      if (isOpponent || isOpponent2) return true
      return false
    }
    if (category === '4BET') {
      if (selectedPosition === 'co4bvsep+mp3bet' && position === 'bu') return true
    }
    if (category === 'vs 4bet') {
      if (isOpponent || isOpponent2) return true
      return false
    }

    if (_betOnTable > 0) return true
    return false
  }

  return (
    <div
      className={
        classnames(
          styles.positionCircleContainer,
          isActive ? styles.active : '',
          isOpponent || isOpponent2 ? styles.opponent : '',
          className,
        )
      }
    >
      <div className={styles.limpOption}>
        {currentOpponentExists() && <span className={styles.opponentPercentage}>{opponentChooser()}</span>}
        {" "}
        {noLimpLabel() && <span className={`${styles.noLimp} ${currentOpponentExists() ? styles.ml5 : ''}`}>No Limp</span>}
      </div>
      <div className={styles.wrap}>
        {position.includes('bu') && <div className={positionDealerChip}>D</div>}
        {position.includes('sb') && hu && <div className={positionDealerChip}>D</div>}

        {(position.includes('bu') && selectedPosition.includes(position))
        && <div className={classnames(styles.bu, positionBet)}>{_betOnTable || ''}</div>}
        {(position.includes('sb') && (selectedPosition.includes(position) || position === 'sb'))
        && <div className={classnames(styles.sb, positionBet)}>{_betOnTable || ''}</div>}
        {(position.includes('bb') && (selectedPosition.includes(position) || position === 'bb'))
        && <div className={classnames(styles.bb, positionBet)}>{_betOnTable || ''}</div>}
        {(position.includes('ep') && selectedPosition.includes(position))
        && <div className={classnames(styles.ep, positionBet)}>{_betOnTable || ''}</div>}
        {(position.includes('mp') && selectedPosition.includes(position))
        && <div className={classnames(styles.mp, positionBet)}>{_betOnTable || ''}</div>}
        {(position.includes('co') && selectedPosition.includes(position))
        && <div className={classnames(styles.co, positionBet)}>{_betOnTable || ''}</div>}
        <div className={styles.innerWrap}>
          <div className={styles.betOption}>
            <H4 className={styles.bet} color={(isOpponent || isOpponent2 || isActive) ? "white" : "dark"}>{ante ? (bet - 0.25) : bet}</H4>
            <H4 className={styles.position} color={(isOpponent || isOpponent2 || isActive) ? "white" : "dark"}>{position.toUpperCase()}</H4>
          </div>
        </div>
      </div>
      {(shouldShowCards()) && (<img src={handleCardColorShow()} onClick={() => handleCardClick()} className={isPlo5 ? styles.cardsPlo5Img : styles.cardsImg}/>)}
    </div>
  );
};

export default PositionCircle;
